import { httpClient } from '@/api/httpClient';
import { resolveAttachmentFilename, type DownloadedFile } from '@/api/fileDownload';

const DEFAULT_EXPORT_FILENAME = 'client-data.zip';

async function downloadExport(path: string): Promise<DownloadedFile> {
  const response = await httpClient.get<Blob>(path, { responseType: 'blob' });
  return {
    blob: response.data,
    filename: resolveAttachmentFilename(
      response.headers['content-disposition'],
      DEFAULT_EXPORT_FILENAME
    ),
  };
}

export function downloadClientDataExport(clientId: string): Promise<DownloadedFile> {
  return downloadExport('/clients/' + clientId + '/data-export');
}

export function downloadOwnDataExport(): Promise<DownloadedFile> {
  return downloadExport('/me/data-export');
}
